import {
  AuraAuthGuard,
  VerifyEmailGuard,
} from '@digital-platform/aura-authentication/guards';
import { FeatureFlagGuard } from '@digital-platform/rs-shared/guards';

export const wpRoutes = [
  {
    path: 'profiling',
    canMatch: [FeatureFlagGuard, AuraAuthGuard, VerifyEmailGuard],
    data: {
      userAction: true, // Brings us back to WP after login
      featureFlags: 'waste-profiling',
    },
    loadChildren: () =>
      import('unified-wp/Module').then((m) => m.RemoteEntryModule),
  },
];
